import { useEffect, useReducer, useRef } from 'react'
import {
  SAVE_FILINGDATA,
  GET_FILINGDETAIL,
  GET_OA_USER_LIST,
  oaUserItem,
  GET_SUPPLIER_PLATFORM_LIST,
} from '../../api/Filing'
import {
  download,
  generateRandomId,
  getSupplierId,
  isResponseCodeSuccess,
} from '../../tools/util'
import { Form, message, notification } from 'antd'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { setModuleDataAction } from '../../modules/pagecache'
import moment from 'moment'
import {
  GET_CODEPRODUCT_DETAIL,
  IMPORT_FILING_PRODUCT,
} from '../../api/MaterialApi'
import reducer, {
  State,
  setUserListdataSourceLoadingAction,
  defaultState,
  setDeleteParamAction,
  setDisabledOperateAction,
  setDisplayTipAction,
  setFillingSheetStateAction,
  setDataSourceLoadingAction,
  setSearchdataAction,
  setStaffModalVisibleAction,
  setDataSourceAction,
  setUserListdataSourceAction,
  setUploadFilesListAction,
  setOriginFileAction,
  setIsImportModalVisibleAction,
  setImportLoadingTipAction,
  setDockingSalesJobNumber,
  reloadStateAction,
  setPlatformListAction,
} from './reducer'
import { RcFile } from 'antd/lib/upload'
import { fileFile } from '../../modules/uploadfiles/hooks'
import { notificationDesRender, Props } from './index'
import { Template_url_filingSheet } from '../../api/template'
import { useCloseTab } from '../../tools/utilHooks'
import { cloneDeep, pick } from 'lodash'
import { AreaInfo } from '../../modules/goodsdetailmodules/reducer'
import { useLocation } from 'react-router-dom'

function findAreaNameBycode(codeList: string[], areaList: AreaInfo[]) {
  const res = cloneDeep(codeList)

  const waitTransformSet = new Set(codeList)
  function travelAreaNode(areaList: AreaInfo[]) {
    for (const item of areaList) {
      if (waitTransformSet.has(item.code)) {
        const waitIndex = codeList.findIndex((code) => code === item.code)
        res[waitIndex] = item.name
        waitTransformSet.delete(item.code)
      }
      if (item?.children) {
        travelAreaNode(item.children)
      }
    }
  }
  travelAreaNode(areaList)
  return res
}
const useFilingHooks = (props?: Props) => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const [form] = Form.useForm()
  const {
    deleteParam,
    dataSource,
    uploadFilesList,
    originFile,
    dockingSalesJobNumber,
    platformList,
    disabledOperate,
  } = state
  const { onCurrentPageClose } = useCloseTab()
  const flag = useRef<boolean>(true)
  const dispatchRedux = useDispatch()
  const { state: routeState, pathname } = useLocation<{ id: string }>()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const areaOptions = useTypedSelector(
    (state) => state.goodsReducer,
  )?.areaOptions?.map((province: any) => {
    return {
      code: province.code,
      name: province.name,
      children: province.children?.map((city: any) => {
        return {
          code: city.code,
          name: city.name,
        }
      }),
    }
  })

  const isH5Detail = props?.detail

  const getPlatformList = async () => {
    const res = await GET_SUPPLIER_PLATFORM_LIST()
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setPlatformListAction(res.data || []))
      return res.data || []
    }
    return []
  }
  // 获取缓存数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 缓存数据
  const onCache = () => {
    // 缓存存数据
    const pathName = history.location.pathname
    const formData = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: state, // 当前状态
        formData: formData,
      },
    })
    dispatchRedux(action)
  }

  useEffect(() => {
    const initData = async () => {
      // 页面初始化：恢复缓存或获取详情
      const cacheData = getpagecache()
      if (cacheData && !routeState) {
        // 有缓存且不是通过state跳转，恢复缓存
        dispatch(reloadStateAction(cacheData.pageState))
        form.setFieldsValue(cacheData.formData)
      } else {
        // 先获取平台列表，确保在调用getFilingNoDetail时platformList已经更新
        const currentPlatformList = await getPlatformList()
        // 没有缓存或通过state跳转，获取详情
        if (routeState?.id) {
          dispatch(setDisplayTipAction(true))
          getInfo(routeState.id, currentPlatformList)
        } else if (props?.id) {
          dispatch(setDisplayTipAction(true))
          getInfo(props.id, currentPlatformList)
        } else {
          dispatch(setDisplayTipAction(false))
        }
      }
    }
    initData()

    // 页面销毁时关闭提醒框
    return () => {
      flag.current = false
      notification.destroy()
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 页面状态变化时缓存数据
    onCache()
    // eslint-disable-next-line
  }, [state])
  const handleFormDataChange = (changedValues: any, allValues: any) => {
    onCache()
  }
  const getInfo = async (id: string, currentPlatformList: any[]) => {
    const res = await GET_FILINGDETAIL({ filingId: id })
    if (isResponseCodeSuccess(res.code)) {
      const data = {
        ...pick(res.data, [
          'validity',
          'customerMdmCode',
          'crmExists',
          // h5字段
          'approvalMan',
        ]),
        customer: res.data.customer,
        filingDeadline: moment(res.data.filingDeadline, 'YYYY-MM-DD'),
        filingNo: res.data.filingNo,
        filingTime: res.data.filingTime,
        id: res.data.id,
        orderTime: moment(res.data.orderTime, 'YYYY-MM-DD'),
        platform: res.data.platform,
        platformName: res.data.platformName,
        price: res.data.price,
        remark: res.data.remark,
        state: res.data.state,
        num: res.data.productList.reduce(
          (prev: any, cur: any) => prev + cur.num,
          0,
        ),
        dockingSalesName: res.data.dockingSalesName,
        dockingSalesId: res.data.dockingSalesId,
        receiveAddressName: res.data?.receiveAddressName?.split(',')?.join('/'),
        receiveAddress: res.data?.receiveAddress?.split(','),
      }
      dispatch(setDockingSalesJobNumber(res.data.dockingSalesJobNumber))
      form.setFieldsValue(data)

      dispatch(
        setFillingSheetStateAction({
          state: res.data.state,
          approvalOpinion: res.data.approvalOpinion || '-',
        }),
      )
      if (isH5Detail) {
        dispatch(setDisabledOperateAction(true))
      } else {
        if (res.data.state !== '审核驳回') {
          dispatch(setDisabledOperateAction(true))
        } else {
          dispatch(setDisabledOperateAction(false))

          // 根据平台code查找平台名称
          const platformCode = res.data.platform
          const platformName = res.data.platformName
          const platformItem = currentPlatformList.find(
            (item: any) => item.platformCode === platformCode,
          )

          // 处理平台字段的值
          let platformValue = platformCode
          let platformNameValue = platformName

          // 编辑模式：如果平台code不在列表中，清空platform字段，让用户重新选择
          if (platformCode && !platformItem) {
            platformValue = ''
            platformNameValue = ''
          }
          form.setFieldsValue({
            platform: platformValue,
            platformName: platformNameValue, // 存储平台名称，用于显示
          })
        }
      }
      console.log(form.getFieldsValue(), 'form.getFieldsValue()')
      const productList: any[] = []
      res.data.productList.forEach((item: any) => {
        if (item.code !== '') {
          productList.push({ ...item, disables: true })
        } else {
          productList.push({ ...item, disables: false })
        }
      })
      dispatch(setDataSourceAction(productList))
      if (res.data.productList.length > 0) {
        setFormValues(res.data.productList)
      }
    }
  }
  const closeTab = () => {
    onCurrentPageClose(() => {
      notification.destroy()
    })
  }
  // 保存备货单
  const saveDate = async () => {
    const formData = await form.validateFields()
    if (typeof formData.crmExists !== 'boolean') {
      message.error('客户信息已失效，请重新选择客户单位')
      return
    }
    if (formData.crmExists && !formData.customerMdmCode) {
      message.error('客户主数据编码为空，请重新选择客户单位')
      return
    }
    const areaNameList = findAreaNameBycode(
      formData.receiveAddress ?? [],
      areaOptions,
    )
    if (formData) {
      dispatch(setDataSourceLoadingAction(true))
      const data = {
        ...pick(formData, ['customerMdmCode', 'crmExists']),
        customer: formData.customer ? formData.customer : '', // 客户单位
        filingDeadline: formData.filingDeadline
          ? moment(formData.filingDeadline).format('YYYY-MM-DD')
          : '', // 报备到期日
        id: formData.id ? formData.id : '', //
        orderTime: formData.orderTime
          ? moment(formData.orderTime).format('YYYY-MM-DD')
          : '', // 预计点单日
        platform: formData.platform ? formData.platform : '', // 下单平台
        price: formData.price ? formData.price : '', // 报备金额
        remark: formData.remark ? formData.remark : '', // 备注
        productList: dataSource.map((item) => ({
          ...item,
          num: Number(item.num),
        })), // 报备单商品明细
        supplierId: getSupplierId(), // 供应商ID
        num: formData.num ? Number(formData.num) : 0,
        dockingSalesId: formData.dockingSalesId, // 对接销售oaid
        dockingSalesName: formData.dockingSalesName, // 对接销售
        receiveAddress: formData.receiveAddress?.join(','),
        receiveAddressName: areaNameList?.join(','),
        dockingSalesJobNumber: dockingSalesJobNumber,
        city: areaNameList?.[1],
        cityCode: formData.receiveAddress?.[1],
        province: areaNameList?.[0],
        provinceCode: formData.receiveAddress?.[0],
      }
      const res = await SAVE_FILINGDATA({ ...data })
      dispatch(setDataSourceLoadingAction(false))
      if (isResponseCodeSuccess(res.code)) {
        message.success('操作成功')
        setTimeout(() => {
          closeTab()
        }, 1000)
      }
    }
  }
  // 设置新数据
  const setNewData = async (e: any, i: any, keyName: string) => {
    const newData = [...dataSource]
    newData[i][keyName] = e
    if (keyName === 'code') {
      if (e) {
        newData[i]['disables'] = true
        newData[i]['loading'] = true
      } else {
        newData[i]['disables'] = false
        newData[i]['loading'] = false
      }
    }
    if (keyName === 'brand' || keyName === 'name' || keyName === 'model') {
      if (e) {
        newData[i]['disablesCode'] = true
      } else {
        newData[i]['disablesCode'] = false
      }
    }
    dispatch(setDataSourceLoadingAction(false))
    dispatch(setDataSourceAction(newData))
    if (keyName === 'code' && e.length > 7) {
      const res = await GET_CODEPRODUCT_DETAIL({
        code: e,
      })
      if (isResponseCodeSuccess(res.code)) {
        newData[i]['brand'] = res.data.brandName
        newData[i]['name'] = res.data.name
        newData[i]['model'] = res.data.model
        newData[i]['loading'] = false
        dispatch(setDataSourceAction(newData))
        const objbrand: any = {},
          objname: any = {},
          objmodel: any = {}
        objbrand[`brand${i}`] = res.data.brandName
        objname[`name${i}`] = res.data.name
        objmodel[`model${i}`] = res.data.model
        const obj = { ...objbrand, ...objname, ...objmodel }
        form.setFieldsValue(obj)
      } else {
        newData[i]['loading'] = false
        dispatch(setDataSourceAction(newData))
      }
    }
  }
  // 新增行
  const handleAdd = () => {
    const newData = {
      id: new Date().valueOf(),
      brand: '',
      code: '',
      model: '',
      name: '',
      num: '',
      price: '',
    }
    dispatch(setDataSourceAction([...dataSource, newData]))
    setFormValues([...dataSource, newData])
  }
  // 删除行
  const deleteTable = () => {
    if (deleteParam.length < 1) {
      message.warning('请勾选要删除的行')
    } else {
      const setData: any[] = []
      dataSource.forEach((item) => {
        if (deleteParam.join().indexOf(item.id) === -1) {
          setData.push(item)
        }
      })
      dispatch(setDeleteParamAction([]))
      dispatch(setDataSourceLoadingAction(false))
      dispatch(setDataSourceAction(setData))
      setFormValues(setData)
      dispatch(setDeleteParamAction([]))
    }
  }
  const selectionChange = (parmas: any[]) => {
    dispatch(setDeleteParamAction(parmas))
  }

  // 对接销售弹框显隐
  const setStaffModalVisible = (val: boolean) => {
    dispatch(setUserListdataSourceLoadingAction(false))
    dispatch(setUserListdataSourceAction([]))
    dispatch(setStaffModalVisibleAction(val))
  }

  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchdataAction(params))
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 获取列表数据
  const getdata = async (DeptDataState: State) => {
    const params = { ...DeptDataState.searchdata }
    // 添加loading
    dispatch(setUserListdataSourceLoadingAction(true))
    const res = await GET_OA_USER_LIST({
      name: params.realName,
      mobile: params.mobile,
    })
    dispatch(setUserListdataSourceLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setUserListdataSourceAction(res.data))
    }
  }

  // 选中查询的员工数据
  const onClickStaffRow = (record: oaUserItem) => {
    setStaffModalVisible(false)
    const formData = form.getFieldsValue()
    dispatch(setDockingSalesJobNumber(record.jobNumber))
    form.setFieldsValue({
      ...formData,
      dockingSalesName: record.name,
      dockingSalesId: record.dingId,
    })
  }

  // 导入弹窗
  const changeImportModalVisible = (val: boolean) => {
    dispatch(setIsImportModalVisibleAction(val))
    if (!val) {
      // 关闭弹窗时清空文件列表
      dispatch(setUploadFilesListAction([]))
    }
  }

  // 导入区域库存确认
  const cofirmImportModal = async () => {
    if (!uploadFilesList.length) {
      message.warning('请上传导入文件')
    } else {
      // 关闭弹窗,设置按钮禁用
      changeImportModalVisible(false)
      dispatch(setImportLoadingTipAction(true))
      message.loading('导入中......', 0)
      const res = await IMPORT_FILING_PRODUCT(originFile)
      // 关闭message,取消按钮禁用
      message.destroy()
      dispatch(setImportLoadingTipAction(false))
      if (isResponseCodeSuccess(res.code)) {
        // 导入文件中存在校验通过的数据时,整理数据
        if (res.data.productInfo.length) {
          const list = res.data.productInfo.map((item: any) => ({
            code: item.code,
            id: generateRandomId(),
            model: item.model,
            name: item.name,
            brand: item.brandName,
            num: item.number,
            price: item.price,
            disables: true,
            loading: false,
          }))
          dispatch(setDataSourceAction([...dataSource, ...list]))
          setFormValues([...dataSource, ...list])
        }
        // 设置提示信息
        const title = `导入完成！成功${res.data.successNumber}条，失败${res.data.failNumber}条`
        openNotification(title, res.data.errorInfo)
      }
    }
  }

  // 下载导入模板
  const downloadTemplate = () => {
    download(Template_url_filingSheet)
  }

  // 修改上传的文件
  const handleUploadfilesChange = (e: fileFile[]) => {
    dispatch(setUploadFilesListAction(e))
  }

  // 获取源文件
  const getOriginFile = (e: RcFile) => {
    dispatch(setOriginFileAction(e))
  }

  // 设置form数据
  const setFormValues = (list: any[]) => {
    const info = JSON.parse(JSON.stringify(list))
    // 循环改变key值
    info.forEach((item: any, index: number) => {
      Object.keys(item).forEach((i) => {
        item[i + index] = item[i]
        delete item[i]
      })
    })
    // 数组转化对象
    const obj: any = {}
    for (let i = 0; i < info.length; i++) {
      const objarr = Object.keys(info[i])
      for (let j = 0; j < objarr.length; j++) {
        obj[objarr[j]] = info[i][objarr[j]]
      }
    }
    form.setFieldsValue(obj)
  }

  // 右侧通知提醒框
  const openNotification = (title: string, desList: string[]) => {
    // 判断当前页面开启/关闭状态
    // 页面关闭时不在展示提示框
    if (flag.current) {
      notification.open({
        message: title,
        description: notificationDesRender(desList),
        duration: null,
        style: {
          overflow: 'auto',
          maxHeight: '85vh',
        },
      })
    }
  }

  useEffect(() => {
    // 商品表格数据发生变化时动态就算价格
    if (dataSource.length) {
      let allPrice = 0,
        allNum = 0
      dataSource.forEach((item) => {
        if (item.num && item.price) {
          allPrice += Number((item.num * item.price).toFixed(2))
        }
        if (item.num) {
          allNum += Number(item.num)
        }
      })
      form.setFieldsValue({ price: allPrice.toFixed(2), num: allNum })
    } else {
      form.setFieldsValue({ price: '', num: '' })
    }
  }, [dataSource])

  return {
    state,
    form,
    areaOptions,
    saveDate,
    setNewData,
    handleAdd,
    deleteTable,
    moment,
    closeTab,
    selectionChange,
    setStaffModalVisible,
    handleSearchClick,
    onClickStaffRow,
    changeImportModalVisible,
    cofirmImportModal,
    downloadTemplate,
    handleUploadfilesChange,
    getOriginFile,
    isH5Detail,
    handleFormDataChange,
  }
}

export default useFilingHooks
import { useEffect, useReducer, useRef } from 'react'
import {
  SAVE_FILINGDATA,
  GET_FILINGDETAIL,
  GET_OA_USER_LIST,
  oaUserItem,
  GET_SUPPLIER_PLATFORM_LIST,
} from '../../api/Filing'
import {
  download,
  generateRandomId,
  getSupplierId,
  isResponseCodeSuccess,
} from '../../tools/util'
import { Form, message, notification } from 'antd'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { setModuleDataAction } from '../../modules/pagecache'
import moment from 'moment'
import {
  GET_CODEPRODUCT_DETAIL,
  IMPORT_FILING_PRODUCT,
} from '../../api/MaterialApi'
import reducer, {
  State,
  setUserListdataSourceLoadingAction,
  defaultState,
  setDeleteParamAction,
  setDisabledOperateAction,
  setDisplayTipAction,
  setFillingSheetStateAction,
  setDataSourceLoadingAction,
  setSearchdataAction,
  setStaffModalVisibleAction,
  setDataSourceAction,
  setUserListdataSourceAction,
  setUploadFilesListAction,
  setOriginFileAction,
  setIsImportModalVisibleAction,
  setImportLoadingTipAction,
  setDockingSalesJobNumber,
  reloadStateAction,
  setPlatformListAction,
} from './reducer'
import { RcFile } from 'antd/lib/upload'
import { fileFile } from '../../modules/uploadfiles/hooks'
import { notificationDesRender, Props } from './index'
import { Template_url_filingSheet } from '../../api/template'
import { useCloseTab } from '../../tools/utilHooks'
import { cloneDeep, pick } from 'lodash'
import { AreaInfo } from '../../modules/goodsdetailmodules/reducer'
import { useLocation } from 'react-router-dom'

function findAreaNameBycode(codeList: string[], areaList: AreaInfo[]) {
  const res = cloneDeep(codeList)

  const waitTransformSet = new Set(codeList)
  function travelAreaNode(areaList: AreaInfo[]) {
    for (const item of areaList) {
      if (waitTransformSet.has(item.code)) {
        const waitIndex = codeList.findIndex((code) => code === item.code)
        res[waitIndex] = item.name
        waitTransformSet.delete(item.code)
      }
      if (item?.children) {
        travelAreaNode(item.children)
      }
    }
  }
  travelAreaNode(areaList)
  return res
}
const useFilingHooks = (props?: Props) => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const [form] = Form.useForm()
  const {
    deleteParam,
    dataSource,
    uploadFilesList,
    originFile,
    dockingSalesJobNumber,
    platformList,
    disabledOperate,
  } = state
  const { onCurrentPageClose } = useCloseTab()
  const flag = useRef<boolean>(true)
  const dispatchRedux = useDispatch()
  const { state: routeState, pathname } = useLocation<{ id: string }>()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const areaOptions = useTypedSelector(
    (state) => state.goodsReducer,
  )?.areaOptions?.map((province: any) => {
    return {
      code: province.code,
      name: province.name,
      children: province.children?.map((city: any) => {
        return {
          code: city.code,
          name: city.name,
        }
      }),
    }
  })

  const isH5Detail = props?.detail

  const getPlatformList = async () => {
    const res = await GET_SUPPLIER_PLATFORM_LIST()
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setPlatformListAction(res.data || []))
      return res.data || []
    }
    return []
  }
  // 获取缓存数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 缓存数据
  const onCache = () => {
    // 缓存存数据
    const pathName = history.location.pathname
    const formData = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: state, // 当前状态
        formData: formData,
      },
    })
    dispatchRedux(action)
  }

  useEffect(() => {
    const initData = async () => {
      // 页面初始化：恢复缓存或获取详情
      const cacheData = getpagecache()
      if (cacheData && !routeState) {
        // 有缓存且不是通过state跳转，恢复缓存
        dispatch(reloadStateAction(cacheData.pageState))
        form.setFieldsValue(cacheData.formData)
      } else {
        // 先获取平台列表，确保在调用getFilingNoDetail时platformList已经更新
        const currentPlatformList = await getPlatformList()
        // 没有缓存或通过state跳转，获取详情
        if (routeState?.id) {
          dispatch(setDisplayTipAction(true))
          getInfo(routeState.id, currentPlatformList)
        } else if (props?.id) {
          dispatch(setDisplayTipAction(true))
          getInfo(props.id, currentPlatformList)
        } else {
          dispatch(setDisplayTipAction(false))
        }
      }
    }
    initData()

    // 页面销毁时关闭提醒框
    return () => {
      flag.current = false
      notification.destroy()
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 页面状态变化时缓存数据
    onCache()
    // eslint-disable-next-line
  }, [state])
  const handleFormDataChange = (changedValues: any, allValues: any) => {
    onCache()
  }
  const getInfo = async (id: string, currentPlatformList: any[]) => {
    const res = await GET_FILINGDETAIL({ filingId: id })
    if (isResponseCodeSuccess(res.code)) {
      const data = {
        ...pick(res.data, [
          'validity',
          'customerMdmCode',
          'crmExists',
          // h5字段
          'approvalMan',
        ]),
        customer: res.data.customer,
        filingDeadline: moment(res.data.filingDeadline, 'YYYY-MM-DD'),
        filingNo: res.data.filingNo,
        filingTime: res.data.filingTime,
        id: res.data.id,
        orderTime: moment(res.data.orderTime, 'YYYY-MM-DD'),
        platform: res.data.platform,
        platformName: res.data.platformName,
        price: res.data.price,
        remark: res.data.remark,
        state: res.data.state,
        num: res.data.productList.reduce(
          (prev: any, cur: any) => prev + cur.num,
          0,
        ),
        dockingSalesName: res.data.dockingSalesName,
        dockingSalesId: res.data.dockingSalesId,
        receiveAddressName: res.data?.receiveAddressName?.split(',')?.join('/'),
        receiveAddress: res.data?.receiveAddress?.split(','),
      }
      dispatch(setDockingSalesJobNumber(res.data.dockingSalesJobNumber))
      form.setFieldsValue(data)

      dispatch(
        setFillingSheetStateAction({
          state: res.data.state,
          approvalOpinion: res.data.approvalOpinion || '-',
        }),
      )
      if (isH5Detail) {
        dispatch(setDisabledOperateAction(true))
      } else {
        if (res.data.state !== '审核驳回') {
          dispatch(setDisabledOperateAction(true))
        } else {
          dispatch(setDisabledOperateAction(false))

          // 根据平台code查找平台名称
          const platformCode = res.data.platform
          const platformName = res.data.platformName
          const platformItem = currentPlatformList.find(
            (item: any) => item.platformCode === platformCode,
          )

          // 处理平台字段的值
          let platformValue = platformCode
          let platformNameValue = platformName

          // 编辑模式：如果平台code不在列表中，清空platform字段，让用户重新选择
          if (platformCode && !platformItem) {
            platformValue = ''
            platformNameValue = ''
          }
          form.setFieldsValue({
            platform: platformValue,
            platformName: platformNameValue, // 存储平台名称，用于显示
          })
        }
      }
      console.log(form.getFieldsValue(), 'form.getFieldsValue()')
      const productList: any[] = []
      res.data.productList.forEach((item: any) => {
        if (item.code !== '') {
          productList.push({ ...item, disables: true })
        } else {
          productList.push({ ...item, disables: false })
        }
      })
      dispatch(setDataSourceAction(productList))
      if (res.data.productList.length > 0) {
        setFormValues(res.data.productList)
      }
    }
  }
  const closeTab = () => {
    onCurrentPageClose(() => {
      notification.destroy()
    })
  }
  // 保存备货单
  const saveDate = async () => {
    const formData = await form.validateFields()
    if (typeof formData.crmExists !== 'boolean') {
      message.error('客户信息已失效，请重新选择客户单位')
      return
    }
    if (formData.crmExists && !formData.customerMdmCode) {
      message.error('客户主数据编码为空，请重新选择客户单位')
      return
    }
    const areaNameList = findAreaNameBycode(
      formData.receiveAddress ?? [],
      areaOptions,
    )
    if (formData) {
      dispatch(setDataSourceLoadingAction(true))
      const data = {
        ...pick(formData, ['customerMdmCode', 'crmExists']),
        customer: formData.customer ? formData.customer : '', // 客户单位
        filingDeadline: formData.filingDeadline
          ? moment(formData.filingDeadline).format('YYYY-MM-DD')
          : '', // 报备到期日
        id: formData.id ? formData.id : '', //
        orderTime: formData.orderTime
          ? moment(formData.orderTime).format('YYYY-MM-DD')
          : '', // 预计点单日
        platform: formData.platform ? formData.platform : '', // 下单平台
        price: formData.price ? formData.price : '', // 报备金额
        remark: formData.remark ? formData.remark : '', // 备注
        productList: dataSource.map((item) => ({
          ...item,
          num: Number(item.num),
        })), // 报备单商品明细
        supplierId: getSupplierId(), // 供应商ID
        num: formData.num ? Number(formData.num) : 0,
        dockingSalesId: formData.dockingSalesId, // 对接销售oaid
        dockingSalesName: formData.dockingSalesName, // 对接销售
        receiveAddress: formData.receiveAddress?.join(','),
        receiveAddressName: areaNameList?.join(','),
        dockingSalesJobNumber: dockingSalesJobNumber,
        city: areaNameList?.[1],
        cityCode: formData.receiveAddress?.[1],
        province: areaNameList?.[0],
        provinceCode: formData.receiveAddress?.[0],
      }
      const res = await SAVE_FILINGDATA({ ...data })
      dispatch(setDataSourceLoadingAction(false))
      if (isResponseCodeSuccess(res.code)) {
        message.success('操作成功')
        setTimeout(() => {
          closeTab()
        }, 1000)
      }
    }
  }
  // 设置新数据
  const setNewData = async (e: any, i: any, keyName: string) => {
    const newData = [...dataSource]
    newData[i][keyName] = e
    if (keyName === 'code') {
      if (e) {
        newData[i]['disables'] = true
        newData[i]['loading'] = true
      } else {
        newData[i]['disables'] = false
        newData[i]['loading'] = false
      }
    }
    if (keyName === 'brand' || keyName === 'name' || keyName === 'model') {
      if (e) {
        newData[i]['disablesCode'] = true
      } else {
        newData[i]['disablesCode'] = false
      }
    }
    dispatch(setDataSourceLoadingAction(false))
    dispatch(setDataSourceAction(newData))
    if (keyName === 'code' && e.length > 7) {
      const res = await GET_CODEPRODUCT_DETAIL({
        code: e,
      })
      if (isResponseCodeSuccess(res.code)) {
        newData[i]['brand'] = res.data.brandName
        newData[i]['name'] = res.data.name
        newData[i]['model'] = res.data.model
        newData[i]['loading'] = false
        dispatch(setDataSourceAction(newData))
        const objbrand: any = {},
          objname: any = {},
          objmodel: any = {}
        objbrand[`brand${i}`] = res.data.brandName
        objname[`name${i}`] = res.data.name
        objmodel[`model${i}`] = res.data.model
        const obj = { ...objbrand, ...objname, ...objmodel }
        form.setFieldsValue(obj)
      } else {
        newData[i]['loading'] = false
        dispatch(setDataSourceAction(newData))
      }
    }
  }
  // 新增行
  const handleAdd = () => {
    const newData = {
      id: new Date().valueOf(),
      brand: '',
      code: '',
      model: '',
      name: '',
      num: '',
      price: '',
    }
    dispatch(setDataSourceAction([...dataSource, newData]))
    setFormValues([...dataSource, newData])
  }
  // 删除行
  const deleteTable = () => {
    if (deleteParam.length < 1) {
      message.warning('请勾选要删除的行')
    } else {
      const setData: any[] = []
      dataSource.forEach((item) => {
        if (deleteParam.join().indexOf(item.id) === -1) {
          setData.push(item)
        }
      })
      dispatch(setDeleteParamAction([]))
      dispatch(setDataSourceLoadingAction(false))
      dispatch(setDataSourceAction(setData))
      setFormValues(setData)
      dispatch(setDeleteParamAction([]))
    }
  }
  const selectionChange = (parmas: any[]) => {
    dispatch(setDeleteParamAction(parmas))
  }

  // 对接销售弹框显隐
  const setStaffModalVisible = (val: boolean) => {
    dispatch(setUserListdataSourceLoadingAction(false))
    dispatch(setUserListdataSourceAction([]))
    dispatch(setStaffModalVisibleAction(val))
  }

  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchdataAction(params))
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 获取列表数据
  const getdata = async (DeptDataState: State) => {
    const params = { ...DeptDataState.searchdata }
    // 添加loading
    dispatch(setUserListdataSourceLoadingAction(true))
    const res = await GET_OA_USER_LIST({
      name: params.realName,
      mobile: params.mobile,
    })
    dispatch(setUserListdataSourceLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setUserListdataSourceAction(res.data))
    }
  }

  // 选中查询的员工数据
  const onClickStaffRow = (record: oaUserItem) => {
    setStaffModalVisible(false)
    const formData = form.getFieldsValue()
    dispatch(setDockingSalesJobNumber(record.jobNumber))
    form.setFieldsValue({
      ...formData,
      dockingSalesName: record.name,
      dockingSalesId: record.dingId,
    })
  }

  // 导入弹窗
  const changeImportModalVisible = (val: boolean) => {
    dispatch(setIsImportModalVisibleAction(val))
    if (!val) {
      // 关闭弹窗时清空文件列表
      dispatch(setUploadFilesListAction([]))
    }
  }

  // 导入区域库存确认
  const cofirmImportModal = async () => {
    if (!uploadFilesList.length) {
      message.warning('请上传导入文件')
    } else {
      // 关闭弹窗,设置按钮禁用
      changeImportModalVisible(false)
      dispatch(setImportLoadingTipAction(true))
      message.loading('导入中......', 0)
      const res = await IMPORT_FILING_PRODUCT(originFile)
      // 关闭message,取消按钮禁用
      message.destroy()
      dispatch(setImportLoadingTipAction(false))
      if (isResponseCodeSuccess(res.code)) {
        // 导入文件中存在校验通过的数据时,整理数据
        if (res.data.productInfo.length) {
          const list = res.data.productInfo.map((item: any) => ({
            code: item.code,
            id: generateRandomId(),
            model: item.model,
            name: item.name,
            brand: item.brandName,
            num: item.number,
            price: item.price,
            disables: true,
            loading: false,
          }))
          dispatch(setDataSourceAction([...dataSource, ...list]))
          setFormValues([...dataSource, ...list])
        }
        // 设置提示信息
        const title = `导入完成！成功${res.data.successNumber}条，失败${res.data.failNumber}条`
        openNotification(title, res.data.errorInfo)
      }
    }
  }

  // 下载导入模板
  const downloadTemplate = () => {
    download(Template_url_filingSheet)
  }

  // 修改上传的文件
  const handleUploadfilesChange = (e: fileFile[]) => {
    dispatch(setUploadFilesListAction(e))
  }

  // 获取源文件
  const getOriginFile = (e: RcFile) => {
    dispatch(setOriginFileAction(e))
  }

  // 设置form数据
  const setFormValues = (list: any[]) => {
    const info = JSON.parse(JSON.stringify(list))
    // 循环改变key值
    info.forEach((item: any, index: number) => {
      Object.keys(item).forEach((i) => {
        item[i + index] = item[i]
        delete item[i]
      })
    })
    // 数组转化对象
    const obj: any = {}
    for (let i = 0; i < info.length; i++) {
      const objarr = Object.keys(info[i])
      for (let j = 0; j < objarr.length; j++) {
        obj[objarr[j]] = info[i][objarr[j]]
      }
    }
    form.setFieldsValue(obj)
  }

  // 右侧通知提醒框
  const openNotification = (title: string, desList: string[]) => {
    // 判断当前页面开启/关闭状态
    // 页面关闭时不在展示提示框
    if (flag.current) {
      notification.open({
        message: title,
        description: notificationDesRender(desList),
        duration: null,
        style: {
          overflow: 'auto',
          maxHeight: '85vh',
        },
      })
    }
  }

  useEffect(() => {
    // 商品表格数据发生变化时动态就算价格
    if (dataSource.length) {
      let allPrice = 0,
        allNum = 0
      dataSource.forEach((item) => {
        if (item.num && item.price) {
          allPrice += Number((item.num * item.price).toFixed(2))
        }
        if (item.num) {
          allNum += Number(item.num)
        }
      })
      form.setFieldsValue({ price: allPrice.toFixed(2), num: allNum })
    } else {
      form.setFieldsValue({ price: '', num: '' })
    }
  }, [dataSource])

  return {
    state,
    form,
    areaOptions,
    saveDate,
    setNewData,
    handleAdd,
    deleteTable,
    moment,
    closeTab,
    selectionChange,
    setStaffModalVisible,
    handleSearchClick,
    onClickStaffRow,
    changeImportModalVisible,
    cofirmImportModal,
    downloadTemplate,
    handleUploadfilesChange,
    getOriginFile,
    isH5Detail,
    handleFormDataChange,
  }
}

export default useFilingHooks
